import {AbstractDictionaryViewModel} from "./abstract-dictionary.view-model";
import {BodyTypeApiModel} from "../../api/models/body-type.api-model";

export class BodyTypeViewModel extends AbstractDictionaryViewModel<BodyTypeApiModel> {
  constructor(protected apiModel: BodyTypeApiModel) {
    super(apiModel);
  }
}
